import React from "react"
import { Link, graphql } from "gatsby"
import parse from "html-react-parser"
import {
  deviceType
} from 'detect-it';

// We're using Gutenberg so we need the block styles
import "@wordpress/block-library/build-style/style.css"
import "@wordpress/block-library/build-style/theme.css"

import Layout from "../components/layout"
import SEO from "../components/seo"
import VimeoPlyrEmbed from "../components/vimeoplyrembed"

import InView from "react-intersection-observer"
import TransitionLink, { TransitionState } from 'gatsby-plugin-transition-link'
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import { motion } from "framer-motion"
import ArrowCircle from '../icons/arrow-circle.svg'
import RelatedWorkPosts from "../components/relatedworkposts" // busted


import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton
} from "react-share";

const transition = { duration: 1.4, ease: [ 0.6, 0.01, -0.5, 0.9 ] }

const WorkPostTemplate = ({ data: { previous, next, post } }) => {
  // const featuredImage = {
  //   fluid: post.featuredImage?.node?.localFile?.childImageSharp?.fluid,
  //   alt: post.featuredImage?.node?.alt || ``,
  // }
  let ogImage = ""
  if(post.seo.opengraphImage) {
    ogImage = post.seo.opengraphImage.sourceUrl
  } else {
    if(post.featuredImage) {
      ogImage = post.featuredImage.node.localFile.childImageSharp.fixed.src
    }
  }
  
  return (
    <Layout>
      <SEO
        title={post.seo?.title}
        opengraphImage={ogImage}
        description={post.seo?.metaDesc}
        metaRobotsNofollow={post.seo?.metaRobotsNofollow}
        metaRobotsNoindex={post.seo?.metaRobotsNoindex}
        canonical={post.seo?.canonical ? post.seo.canonical : post.uri}
      />

      <TransitionState>
         {
           ({ transitionStatus, entry, exit }) => {
             return (
               <article
                 className="pt-24"
                 itemScope
                 itemType="http://schema.org/Article"
               >
                 <header className="text-white">
                   <div className="container px-0 lrg:px-7">
                    <div className="note:px-6">
                       <VimeoPlyrEmbed
                         title={parse(post.title)}
                         textAlign="text-left"
                         autoPlay={true}
                         source={post.workPostFields.heroVideo}
                         posterImg={(post.featuredImage) ? post.featuredImage.node.localFile.childImageSharp.fixed.src : false}
                       />
                     </div>
                   </div>

                  <div className="container">

                     <div className="flex justify-between text-black py-10 tab:py-20">

                       <div className="hidden tab:block tab:w-1/12 tab:px-6">
                         {previous && (
                           <AniLink preventScrollJump cover direction="left" bg="#FFFFFF" to={previous.uri} rel="prev">
                             <span className="arrow-circle arrow-circle--left">{parse(previous.title)}</span>
                           </AniLink>
                         )}
                       </div>
                       <div className="tab:w-8/12 tab:px-6">

                         <InView threshold={0.25} triggerOnce >
                           {({ ref, inView }) => (
                             <motion.div
                               ref={ref}
                               initial={{opacity: 0, y: 40}}
                               animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
                               transition={{duration: 0.8}}>

                                 <h2 className="text-base med:text-md mb-4 med:mb-10">{(deviceType === 'mouseOnly') ? 'Overview' : parse(post.title)}</h2>
                                 <p className="text-base med:text-md">{parse(post.workPostFields.overview)}</p>

                             </motion.div>
                           )}
                         </InView>

                         <InView threshold={0.25} triggerOnce >
                           {({ ref, inView }) => (
                             <motion.div
                               ref={ref}
                               initial={{opacity: 0, y: 40}}
                               animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
                               transition={{duration: 0.8}}>

                                 <div className="flex flex-wrap mt-20">
                                   {
                                     post.workPostFields.roles && post.workPostFields.roles.map((role, index) => {
                                       return (
                                         <div className="w-1/2">
                                           <p className="mb-6"><strong>{role.label}</strong><br/>{role.content}</p>
                                         </div>

                                       )
                                     })
                                   }
                                   <div className="w-1/2">
                                     {
                                       (post.workCategories.nodes.length) ?
                                         <p className="mb-6">
                                           <strong>Categories</strong><br/>
                                           {
                                             post.workCategories.nodes.map((cat, index) => {
                                               return (
                                                 <>
                                                   <Link className="underline" to={cat.uri}>{cat.name}</Link>
                                                   {(index+1 < post.workCategories.nodes.length) ? <>,&nbsp;</> : ''}
                                                 </>
                                               )
                                             })
                                           }
                                         </p>
                                       : ''
                                     }
                                     <p className="mb-12"><strong>Share Project</strong><br/><FacebookShareButton url={`https://www.standbyproductions.co.uk${post.link}`}>Facebook</FacebookShareButton>, <TwitterShareButton url={`https://www.standbyproductions.co.uk${post.link}`}>Twitter</TwitterShareButton>, <LinkedinShareButton url={`https://www.standbyproductions.co.uk/${post.link}`}>Linkedin</LinkedinShareButton></p>
                                     
                                     <Link to="/work/" className="underline hover:no-underline"><ArrowCircle className={`inline-block mr-4 fill-current text-black transform rotate-180`} />Back to Work</Link>
                                   </div>
                                 </div>

                             </motion.div>
                           )}
                         </InView>


                       </div>

                       <div className="hidden tab:block tab:w-1/12 tab:px-6">
                         {next && (
                           <AniLink preventScrollJump cover direction="left" bg="#FFFFFF" to={next.uri} rel="next">
                             <span className="arrow-circle arrow-circle--right">{parse(next.title)}</span>
                           </AniLink>
                         )}
                       </div>

                     </div>

                   </div>
                 </header>

                 {
                   (post.workPostFields.additionalContent) ?
                     <section itemProp="articleBody" className="article-body pb-20">
                       <div className="flex justify-center">
                         <div className="desk:w-8/12 desk:px-3">
                           {parse(post.workPostFields.additionalContent)}
                         </div>
                       </div>
                     </section>
                   : ''
                 }

                 {
                   (post.workSectors.nodes) ?
                     <RelatedWorkPosts workSectors={post.workSectors.nodes} />
                   : ''
                 }


               </article>
             )
           }
         }
      </TransitionState>
    </Layout>
  )
}

export default WorkPostTemplate

export const pageQuery = graphql`
  query WorkPostById(
    # these variables are passed in via createPage.pageContext in gatsby-node.js
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    # selecting the current post by id
    post: wpWork(id: { eq: $id }) {
      id
      uri
      link
      title
      date(formatString: "MMMM DD, YYYY")
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
      }
      workPostFields {
        heroVideo
        overview
        roles {
          label
          content
        }
        additionalContent
      }
      workCategories {
        nodes {
          uri
          name
        }
      }
      workSectors {
        nodes {
          uri
          name
        }
      }
      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              fixed(width: 1280, height: 720) {
                ...GatsbyImageSharpFixed_withWebp
              }
            }
          }
        }
      }
    }

    # this gets us the previous post by id (if it exists)
    previous: wpWork(id: { eq: $previousPostId }) {
      uri
      title
    }

    # this gets us the next post by id (if it exists)
    next: wpWork(id: { eq: $nextPostId }) {
      uri
      title
    }
  }
`
